import { useState, type FormEvent } from 'react'

import { api, ErrorApi, type Usuario } from '../api'

export function Acceso({ alEntrar }: { alEntrar: (u: Usuario) => void }) {
  const [modo, setModo] = useState<'entrar' | 'registro'>('entrar')
  const [nombre, setNombre] = useState('')
  const [correo, setCorreo] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [aviso, setAviso] = useState('')
  const [enviando, setEnviando] = useState(false)

  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setAviso('')
    setEnviando(true)
    try {
      if (modo === 'entrar') {
        const { usuario } = await api.entrar(correo, password)
        alEntrar(usuario)
      } else {
        await api.registrar(nombre, correo, password)
        setAviso('Cuenta creada. El administrador tiene que aprobarla antes de que puedas entrar.')
        setModo('entrar')
        setPassword('')
      }
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'Algo salio mal.')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="acceso">
      <form className="tarjeta tarjeta-acceso" onSubmit={enviar}>
        <img
          className="logo"
          src="https://www.sunsmartec.com/wp-content/uploads/2025/03/logo_sunsmartec.png"
          alt="SunSmart"
        />
        <h1>{modo === 'entrar' ? 'Entrar al panel' : 'Crear cuenta'}</h1>

        {modo === 'registro' && (
          <label>
            Nombre
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} autoComplete="name" required />
          </label>
        )}
        <label>
          Correo
          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            autoComplete="email"
            required
          />
        </label>
        <label>
          Contraseña
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={modo === 'entrar' ? 'current-password' : 'new-password'}
            minLength={modo === 'registro' ? 10 : undefined}
            required
          />
          {modo === 'registro' && <small className="ayuda">Mínimo 10 caracteres.</small>}
        </label>

        {error && <p className="error">{error}</p>}
        {aviso && <p className="exito">{aviso}</p>}

        <button className="primario" disabled={enviando}>
          {enviando ? 'Un momento…' : modo === 'entrar' ? 'Entrar' : 'Crear cuenta'}
        </button>

        <p className="cambiar">
          {modo === 'entrar' ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'}{' '}
          <button
            type="button"
            className="enlace"
            onClick={() => {
              setModo(modo === 'entrar' ? 'registro' : 'entrar')
              setError('')
            }}
          >
            {modo === 'entrar' ? 'Regístrate' : 'Entra'}
          </button>
        </p>
      </form>
    </div>
  )
}
